/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagensResumoAliases {
  AVATAR_MENSAGEM = 'avatar-mensagem',
  DECK_MENSAGENS = 'deck-mensagens',
  FETCH_MENSAGENS = 'fetch-mensagens',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_IMPORTANT = 'field-important',
  HPMS_CUSTOM_CARD_MENSAGENS = 'hpms-custom-card-mensagens',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_0 = 'text-0',
}
export { MensagensResumoAliases };
